<template>
  <div>
    <vxe-modal
      v-model="dialogVisible"
      :before-hide-method="handleCancel"
      width="80%"
      show-zoom
      resize
      transfer
    >
      <template #title>
        <span>抓拍图片对比</span>
      </template>
      <template #default>
        <div class="course-snap-contrast-wrapper">
          <div class="course-snap-contrast-item">
            <p>身份证图片：</p>
            <img :src="currentRow.comparePhotograph" alt="" />
          </div>
          <div class="course-snap-contrast-item">
            <p>抓拍图片：</p>
            <img :src="currentRow.studyPhotograph" alt="" />
          </div>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  name: "CourseSnapContrast",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentRow: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    handleCancel() {
      this.$emit("handle-cancel");
    },
  },
};
</script>
<style lang="scss" scoped>
.course-snap-contrast-wrapper {
  display: flex;
  .course-snap-contrast-item {
    flex: 1;
    img {
      width: 100%;
    }
  }
}
</style>